// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { AxiosError, AxiosResponse } from 'axios';
import { ofType } from 'redux-observable';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ActionType, getType } from 'typesafe-actions';

import { getChallengeRelated } from '../../apis/challenge';
import { LoadingType } from '../../types/Common';
import { ChallengeCardType } from '../../types/Model';
import { getChallengeRelatedActions } from '../actionCreators/getChallengeRelatedActions';
import { RootAction } from '../rootActionCreator';

const outputActions = {
  success: getChallengeRelatedActions.success,
  failure: getChallengeRelatedActions.failure
};

type RequestActionTypes = ActionType<
  typeof getChallengeRelatedActions.request
>;
type OutputActionTypes = ActionType<typeof outputActions>;

export const getChallengeRelatedEpic = (
  action$: Observable<RootAction>
): Observable<OutputActionTypes> => {
  return action$.pipe(
    ofType(
      // action filter
      getType(getChallengeRelatedActions.request)
    ),
    switchMap((action: RequestActionTypes) => {
      // prepare api params
      const { id, loadingType = LoadingType.NEW } = action.payload;
      // send api promise
      return getChallengeRelated(id)
        .then((response: AxiosResponse<ChallengeCardType[]>) => {
          // handle success case here
          return getChallengeRelatedActions.success({
            ChallengeRelatedData: response.data,
            id,
            loadingType
          });
        })
        .catch((error: AxiosError) => {
          // handle error case here
          return getChallengeRelatedActions.failure({ error });
        });
    })
  );
};
